import { useEffect } from 'react';

const AccessibilityKeyboardShortcuts = ({ settings, updateSetting }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only trigger shortcuts when accessibility widget is enabled
      if (!settings) return;

      // Alt + A: Toggle accessibility widget
      if (e.altKey && e.key.toLowerCase() === 'a') {
        e.preventDefault();
        const widget = document.querySelector('.accessibility-widget-toggle');
        if (widget) widget.click();
      }

      // Alt + +: Increase font size
      if (e.altKey && e.key === '+') {
        e.preventDefault();
        updateSetting('fontSize', Math.min(200, settings.fontSize + 25));
      }

      // Alt + -: Decrease font size
      if (e.altKey && e.key === '-') {
        e.preventDefault();
        updateSetting('fontSize', Math.max(75, settings.fontSize - 25));
      }

      // Alt + 0: Reset font size
      if (e.altKey && e.key === '0') {
        e.preventDefault();
        updateSetting('fontSize', 100);
      }

      // Alt + C: Cycle through contrast modes
      if (e.altKey && e.key.toLowerCase() === 'c') {
        e.preventDefault();
        const contrastModes = ['normal', 'high', 'dark', 'inverted'];
        const currentIndex = contrastModes.indexOf(settings.contrast);
        const nextIndex = (currentIndex + 1) % contrastModes.length;
        updateSetting('contrast', contrastModes[nextIndex]);
      }

      // Alt + H: Toggle highlight links
      if (e.altKey && e.key.toLowerCase() === 'h') {
        e.preventDefault();
        updateSetting('highlightLinks', !settings.highlightLinks);
      }

      // Alt + R: Toggle reading guide
      if (e.altKey && e.key.toLowerCase() === 'r') {
        e.preventDefault();
        updateSetting('readingGuide', !settings.readingGuide);
      }

      // Alt + M: Toggle animations
      if (e.altKey && e.key.toLowerCase() === 'm') {
        e.preventDefault();
        updateSetting('animations', !settings.animations);
      }

      // Alt + S: Speak page content
      if (e.altKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        const speakBtn = document.querySelector('.accessibility-tts-btn');
        if (speakBtn) speakBtn.click();
      }

      // Alt + Shift + S: Speak current section
      if (e.altKey && e.shiftKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        const speakButtons = document.querySelectorAll('.accessibility-tts-btn');
        if (speakButtons[1]) speakButtons[1].click(); // Click "Read Current Section" button
      }

      // Escape: Close accessibility widget
      if (e.key === 'Escape') {
        const widget = document.querySelector('.accessibility-widget-panel');
        if (widget) {
          const closeBtn = widget.querySelector('.accessibility-close-btn');
          if (closeBtn) closeBtn.click();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [settings, updateSetting]);

  return null; // This component doesn't render anything
};

export default AccessibilityKeyboardShortcuts;
